export default __webpack_public_path__ + "static/media/pfe.bfe602c4.PNG";